import Section from '../../../components/section'
import Text from '../../../components/text'
import Flex from '../../../components/flex'
import Button from '../../../components/button'
import VehicleDetailCard from '../../../components/vehicleDetailCard'
import { useNavigate } from "react-router-dom"
import Modal from "../../../components/modal";
import React from "react";

const VehicleView = props => {
    const {
        vehiclesList,
        gotoAddVehicleInformation,
        deleteVehicleById,
        isConfirmDeleteModal,
        onClosConfirmDeleteModal,
        onOpenConfirmDeleteModal,
        vehicleIDToDelete,
        vehiclesMakeList
    } = props;
    const navigate = useNavigate();

    const getVehicleMake = (makeId)=>{
        let makeName = ''
        vehiclesMakeList?.map((item)=>{
            if(makeId == item.name) {
                makeName = item.name
            }
        })
        return makeName

    }

    return (
        <Section>
            <Flex justifyContent="between" alignItemsCenter className="mb-3">
                <Text type="H1" text="Vehicles" />
                <Button 
                    type="button" 
                    text="+ ADD VEHICLE"
                    onClick={gotoAddVehicleInformation}
                    disabled={vehiclesList.length > 4 }
                />
            </Flex>
            <div className="row">
                {vehiclesList && vehiclesList?.map((vehicle, index) => {

                    return (
                        <div className="col-12 col-md-4">
                            <VehicleDetailCard
                                onDelete={()=>onOpenConfirmDeleteModal(vehicle?.id)}
                                key={'vehicle-' + index}
                                make={getVehicleMake(vehicle?.make)}
                                model={vehicle?.model}
                                color={vehicle?.color}
                                licensePlateState={vehicle?.license_state}
                                licensePlateNumber={vehicle?.license_plate_number}
                                onEdit={() => navigate('/vehicle/edit-vehicle-information/'+vehicle?.id)}
                                isElectric={vehicle?.is_electric == 1}
                            />
                        </div>
                    )})}
            </div>

            {isConfirmDeleteModal &&
                <Modal
                    modalSmall
                    light
                    canClose={false}
                    onClose={onClosConfirmDeleteModal}
                    modalContent={
                        <Flex className="gap-3" flexColumn justifyContent="center" alignItemsCenter>
                            <Text className="text-center" type={"H4"} text={"Are you sure"} />
                            <Flex justifyContent="center" alignItemsCenter className={"gap-3"}>
                                <Button type="button" text={"yes"} onClick={()=>{deleteVehicleById(vehicleIDToDelete)}} />
                                <Button type="button" link text={"No"} onClick={onClosConfirmDeleteModal} />

                            </Flex>
                        </Flex>
                    }
                />
            }
        </Section>


    )
}

export default VehicleView